export default __webpack_public_path__ + "src/images/unsplash/899855d94e49a6963f0c60154f9d9f03-boat-in-ocean.jpg";